// Función para generar un número de tarjeta de crédito válido
export const generateCreditCard = (prefix = '4') => {
  // Asegurarse de que el prefijo sea un string
  const prefixStr = prefix.toString();
  
  // Generar longitud aleatoria (entre 13 y 19 dígitos, dependiendo del tipo de tarjeta)
  let length = 16; // Longitud estándar para la mayoría de tarjetas
  
  if (prefixStr.startsWith('34') || prefixStr.startsWith('37')) {
    length = 15; // American Express
  } else if (prefixStr.startsWith('4')) {
    length = [13, 16, 19][Math.floor(Math.random() * 3)]; // Visa puede ser 13, 16 o 19
  }
  
  // Generar los dígitos aleatorios
  let cardNumber = prefixStr;
  const remainingLength = length - prefixStr.length - 1; // -1 para el dígito de verificación
  
  for (let i = 0; i < remainingLength; i++) {
    cardNumber += Math.floor(Math.random() * 10).toString();
  }
  
  // Calcular el dígito de verificación usando el algoritmo de Luhn
  let sum = 0;
  let shouldDouble = false;
  
  // Recorrer de derecha a izquierda
  for (let i = cardNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cardNumber.charAt(i));
    
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    
    sum += digit;
    shouldDouble = !shouldDouble;
  }
  
  // El dígito de verificación es lo que se necesita para hacer que la suma sea divisible por 10
  const checkDigit = (10 - (sum % 10)) % 10;
  
  // Añadir el dígito de verificación al número de tarjeta
  cardNumber += checkDigit.toString();
  
  return cardNumber;
};

// Función para formatear un número de tarjeta con espacios cada 4 dígitos
export const formatCardNumber = (number) => {
  return number.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
};

// Función para generar un ID único
export const generateId = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

// Función para obtener la fecha actual formateada
export const getCurrentDate = () => {
  const now = new Date();
  return now.toISOString().split('T')[0];
};

// Función para calcular el checksum de Luhn
export const calculateChecksum = (numberWithoutChecksum) => {
  let sum = 0;
  let alternate = true;
  
  for (let i = numberWithoutChecksum.length - 1; i >= 0; i--) {
    let n = parseInt(numberWithoutChecksum.charAt(i), 10);
    if (alternate) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    alternate = !alternate;
  }
  
  return (10 - sum % 10) % 10;
};

// Función para obtener un BIN popular aleatorio
export const getRandomPopularBin = () => {
  const popularBins = [
    '543440xxxxxxxxxx',
    '414720xxxxxxxxxx', 
    '511590xxxxxxxxxx',
    '424242xxxxxxxxxx',
    '377777xxxxxxxxx'
  ];
  return popularBins[Math.floor(Math.random() * popularBins.length)];
};

// Función para descargar un archivo
export const downloadFile = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export default {
  generateCreditCard,
  formatCardNumber,
  generateId,
  getCurrentDate,
  calculateChecksum,
  getRandomPopularBin,
  downloadFile
};